"use strict";

var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
exports.commonjsGlobal = e, exports.createCommonjsModule = function (e, t, r) {
  return e(r = {
    path: t,
    exports: {},
    require: function require(e, t) {
      return function () {
        throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
      }(null == t && r.path);
    }
  }, r.exports), r.exports;
}, exports.getAugmentedNamespace = function (e) {
  if (e.__esModule) return e;
  var t = Object.defineProperty({}, "__esModule", {
    value: !0
  });
  return Object.keys(e).forEach(function (r) {
    var o = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(t, r, o.get ? o : {
      enumerable: !0,
      get: function get() {
        return e[r];
      }
    });
  }), t;
}, exports.getDefaultExportFromCjs = function (e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e["default"] : e;
};